/** @jsxImportSource @emotion/react */

import type { MenuProps } from "antd";
import { Menu } from "antd";
import { ReactComponent as EventIcon } from "assets/desktop/icons/menu/event.svg";
import { ReactComponent as FavouriteIcon } from "assets/desktop/icons/menu/favourite.svg";
import { ReactComponent as HistoryIcon } from "assets/desktop/icons/menu/history-order.svg";
import { ReactComponent as MailIcon } from "assets/desktop/icons/menu/mail.svg";
import { ReactComponent as NotificationIcon } from "assets/desktop/icons/menu/notification.svg";
import { ReactComponent as RefundIcon } from "assets/desktop/icons/menu/refund.svg";
import { ReactComponent as SecuritySettingIcon } from "assets/desktop/icons/menu/security-setting.svg";
import { ReactComponent as TransactionListIcon } from "assets/desktop/icons/menu/transaction-list.svg";
import { ReactComponent as VIPIcon } from "assets/desktop/icons/menu/Vip.svg";
import { PATH } from "constants/path";
import _map from "lodash/map";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import { MenuUserStyle } from "./index.style";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group",
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}
const items: MenuItem[] = _map(
  [
    {
      label: "Cài đặt bảo mật",
      path: PATH.User.SecuritySetting,
      icon: <SecuritySettingIcon />,
    },
    {
      label: "Khu vực VIP",
      path: PATH.User.MemberVip,
      icon: <VIPIcon />,
    },
    {
      label: "Thông báo mới nhất",
      path: PATH.User.Announcement,
      icon: <NotificationIcon />,
    },
    {
      label: "Thư nội bộ",
      path: PATH.User.InternalMail,
      icon: <MailIcon />,
    },
    {
      label: "Khu sự kiện",
      path: PATH.User.Event,
      icon: <EventIcon />,
    },
    {
      label: "Chi Tiết Giao Dịch",
      path: PATH.User.Transactions,
      icon: <TransactionListIcon />,
    },
    {
      label: "Lịch Sử Đặt Cược",
      path: PATH.User.BettingHistory,
      icon: <HistoryIcon />,
    },
    {
      label: "Hoàn trả",
      path: PATH.User.Refund,
      icon: <RefundIcon />,
    },
    {
      label: "Yêu thích nhất",
      path: PATH.User.FavouriteGame,
      icon: <FavouriteIcon />,
    },
  ],
  (item) =>
    getItem(<Link to={item.path}>{item.label}</Link>, item.path, item.icon),
);

const MenuUser = () => {
  const location = useLocation();

  const selectedKeys = useMemo(() => {
    return [location.pathname];
  }, [location]);

  return (
    <div css={MenuUserStyle.self}>
      <Menu selectedKeys={selectedKeys} items={items} />
    </div>
  );
};

export default MenuUser;
